import { FC, useState } from "react";
import { Box } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import DiscountOutlinedIcon from "@mui/icons-material/DiscountOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";

import SingleDetail from "../../../atoms/single-detail/single-detail";
import { Colors } from "../../../../configs";
import { useAppSelector } from "../../../../hooks";
import useCart from "../../../../hooks/useCart";
import DiscountModal from "../../../pos/discount-modal/discountModal";
import TaxExceptionModal from "../../../pos/tax-exception-modal/TaxExceptionModal";
import { formatCurrency } from "../../../../util/common-functions";

export interface IOrderDetailSectionProps {}

const OrderDetailSection: FC<IOrderDetailSectionProps> = () => {
  const [discountModalOpen, setDiscountModalOpen] = useState(false);
  const [taxExceptionModalOpen, setTaxExceptionModalOpen] = useState(false);
  const { getPieceCount, sessionTotal, selectedSessionDiscount } = useCart();
  const { selectedSession } = useAppSelector((state) => state.cart);
  const { customer } = useAppSelector((state) => state.customer);
  const taxEnabled =
    useAppSelector(
      (state) => state.merchant.merchantListResponse?.body?.[0]?.taxEnabled
    ) ?? false;

  const closeDiscountModal = () => {
    setDiscountModalOpen(false);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        background: Colors.WHITE,
        borderRadius: "1.25rem",
        padding: "0.85rem",
        gap: "0.428571429rem",
        maxHeight: "16.07142857142857rem",
        maxWidth: "28.21428571428571rem",
        boxShadow: "0 0.2rem 0.85rem rgba(0,0,0,0.07)",
        border: "1px solid #EFEFEF",
      }}
    >
      <DiscountModal open={discountModalOpen} onClose={closeDiscountModal} />

      <TaxExceptionModal
        open={taxExceptionModalOpen}
        onClose={() => setTaxExceptionModalOpen(false)}
        customerId={customer?.id ?? 0}
      />

      <SingleDetail
        label="Piece Count"
        value={getPieceCount()}
        numberOfColumns={1}
        color={Colors.PRIMARY}
        icon={<Inventory2OutlinedIcon sx={{ fontSize: "1.14rem", color: Colors.WHITE }} />}
      />
      <SingleDetail
        label="Subtotal"
        value={formatCurrency({ amount: sessionTotal, prefix: "$" })}
        numberOfColumns={1}
        color={Colors.PRIMARY}
        icon={<LocalOfferOutlinedIcon sx={{ fontSize: "1.14rem", color: Colors.WHITE }} />}
      />
      <SingleDetail
        label="Discounts"
        value={formatCurrency({ amount: selectedSessionDiscount, prefix: "$" })}
        numberOfColumns={1}
        color={Colors.PRIMARY}
        onClick={selectedSession ? () => setDiscountModalOpen(true) : undefined}
        icon={<DiscountOutlinedIcon sx={{ fontSize: "1.14rem", color: Colors.WHITE }} />}
      />
      <SingleDetail
        label="Tax"
        value={formatCurrency({ amount: 0, prefix: "$" })}
        numberOfColumns={1}
        color={taxEnabled && customer?.id ? Colors.PRIMARY : Colors.ACCENT_GRAY}
        onClick={
          taxEnabled && customer?.id
            ? () => setTaxExceptionModalOpen(true)
            : undefined
        }
        icon={<ReceiptOutlinedIcon sx={{ fontSize: "1.14rem", color: Colors.WHITE }} />}
      />
      <SingleDetail
        label="Total"
        value={formatCurrency({
          amount: sessionTotal - selectedSessionDiscount,
          prefix: "$",
        })}
        numberOfColumns={1}
        color={Colors.PRIMARY}
        icon={<CalculateOutlinedIcon sx={{ fontSize: "1.14rem", color: Colors.WHITE }} />}
      />
    </Box>
  );
};

export default OrderDetailSection;
